var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLongArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.417,
    height: 12.523,
    viewBox: "0 0 16.417 12.523",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.115 0.58)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.287,
    height: 1.861,
    rx: 0.931,
    transform: "translate(0.015 4.63)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.548,0H7.832c.3,0,.548.363.548.811s-.245.811-.548.811H.548C.245,1.621,0,1.258,0,.811S.245,0,.548,0Z",
    transform: "translate(1.22 4.63) rotate(48)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.548,0H7.832c.3,0,.548.363.548.811s-.245.811-.548.811H.548C.245,1.621,0,1.258,0,.811S.245,0,.548,0Z",
    transform: "translate(6.957 0.566) rotate(135)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongArrow);
export default __webpack_public_path__ + "static/media/longArrow.476dd14d8f4d7b0815ab35c2cea73b8b.svg";
export { ForwardRef as ReactComponent };